<section id="portfolio" class="portfolio">
  <div class="container">

    <div class="section-title">
      <h2 data-aos="fade-up">{{ lastCompletedContestYear }} Winners' Gallery</h2>
    </div>

    <div class="row" data-aos="fade-up" data-aos-delay="100">
      <div class="col-lg-12 d-flex justify-content-center">
        <ul id="portfolio-flters">
          <li (click)="filterPictures(0)" [ngClass]="{'filter-active' : gradeCategoryId === 0}">All</li>
          <li (click)="filterPictures(1)" [ngClass]="{'filter-active' : gradeCategoryId === 1}">K-2</li>
          <li (click)="filterPictures(2)" [ngClass]="{'filter-active' : gradeCategoryId === 2}">3-5</li>
          <li (click)="filterPictures(3)" [ngClass]="{'filter-active' : gradeCategoryId === 3}">6-8</li>
          <li (click)="filterPictures(4)" [ngClass]="{'filter-active' : gradeCategoryId === 4}">9-12</li>
        </ul>
      </div>
    </div>

    <div class="row portfolio-container" data-aos="fade-up" data-aos-delay="200">

      <div class="col-md-3 portfolio-item" *ngFor="let winner of filteredContestWinners">
        <img [src]="winner.pictureThumbName" class="img-fluid" alt="">
        <div class="portfolio-info">
          <p>{{winner.firstName}} {{winner.lastName}} ({{ winner.voteChoice }}) - {{ winner.grade }} </p>
        </div>
      </div>

    </div>

  </div>
</section>
